<template>
  <div class="container">
    <!-- 日/ 週 / 月 選択エリア
      期間選択エリアの表示切替のトリガーです。 -->
    <div>
      <md-radio
        v-for="term in filteredTermTypes"
        :key="term.id"
        v-model="_termType"
        :value="term.id"
        >{{ term.label }}</md-radio
      >
    </div>
    <!-- 期間選択エリア -->
    <div>
      <transition mode="out-in">
        <!-- 週の選択 -->
        <div v-if="isWeekMode" key="w">
          <div class="term-input">
            <div class="divider">当期間</div>
            <!-- 当期 -->
            <gl-input-date
              v-if="baseWeekCountFrom"
              :min="minDate"
              :max="maxDate"
              :value.sync="BaseWeekFrom"
            />
            <gl-input-date
              v-if="baseWeekCountTo"
              :min="minDate"
              :max="maxDate"
              :value.sync="BaseWeekTo"
            />
            <md-field class="weekType">
              <md-select v-model="_baseWeekType">
                <md-option
                  v-for="week in weekTypes"
                  :value="week.id"
                  :key="week.id"
                >
                  {{ week.label }}
                </md-option>
              </md-select>
            </md-field>
            <md-field class="week-count">
              <md-input
                v-model.number="BaseWeekCount"
                type="number"
                :min="1"
                :max="BaseMaxWeek"
                required
              ></md-input>
            </md-field>
            <div class="divider">
              <span>週間</span>
            </div>
          </div>
          <!-- 前期 -->
          <div class="term-input">
            <div class="divider">前期間</div>
            <gl-input-date
              v-if="compareWeekCountFrom"
              :min="minDate"
              :max="maxDate"
              :value.sync="CompareWeekFrom"
            />
            <gl-input-date
              v-if="compareWeekCountTo"
              :min="minDate"
              :max="maxDate"
              :value.sync="CompareWeekTo"
            />
            <md-field class="weekType">
              <md-select v-model="_compareWeekType">
                <md-option
                  v-for="week in weekTypes"
                  :value="week.id"
                  :key="week.id"
                >
                  {{ week.label }}
                </md-option>
              </md-select>
            </md-field>
            <md-field class="week-count">
              <md-input
                v-model.number="CompareWeekCount"
                type="number"
                :min="1"
                :max="CompareMaxWeek"
                required
              ></md-input>
            </md-field>
            <div class="divider">週間</div>
          </div>
        </div>
        <!-- 月の選択 -->
        <div v-if="isMonthMode" key="m">
          <div class="term-input">
            <div class="divider">当期間</div>
            <!-- 当期 -->
            <gl-select-month
              :min="minDate"
              :max="maxDate"
              :value.sync="BaseMonthTo"
            />
            <div class="divider">まで</div>
            <md-field>
              <md-input
                v-model.number="BaseMonthCount"
                type="number"
                :min="1"
                :max="BaseMaxMonth"
                required
              ></md-input>
            </md-field>
            <div class="divider">ヶ月</div>
          </div>
          <!-- 前期 -->
          <div class="term-input">
            <div class="divider">前期間</div>
            <gl-select-month
              :min="minDate"
              :max="maxDate"
              :value.sync="CompareMonthTo"
            />
            <div class="divider">まで</div>
            <md-field>
              <md-input
                v-model.number="CompareMonthCount"
                type="number"
                :min="1"
                :max="CompareMaxMonth"
                required
              ></md-input>
            </md-field>
            <div class="divider">ヶ月</div>
          </div>
        </div>
        <!-- 日の選択-->
        <div v-if="isDateMode" key="d">
          <div class="term-input">
            <div class="divider">当期間</div>
            <!-- 当期 -->
            <gl-input-date
              :min="minDate"
              :max="maxDate"
              :value.sync="BaseDateFrom"
            />
            <div class="divider">～</div>
            <gl-input-date
              :min="minDate"
              :max="maxDate"
              :value.sync="BaseDateTo"
            />
          </div>
          <!-- 前期 -->
          <div class="term-input">
            <div class="divider">前期間</div>

            <gl-input-date
              :min="minDate"
              :max="maxDate"
              :value.sync="CompareDateFrom"
            />
            <div class="divider">～</div>
            <gl-input-date
              :min="minDate"
              :max="maxDate"
              :value.sync="CompareDateTo"
            />
          </div>
        </div>
        <!-- 日・曜日選択 -->
        <div v-if="isSelectMode" key="select">
          <!-- 当期 -->
          <div class="term-input">
            <gl-input-date
              :min="minDate"
              :max="maxDate"
              :value.sync="BaseDateFrom"
            />
            <div class="divider">～</div>
            <gl-input-date
              :min="minDate"
              :max="maxDate"
              :value.sync="BaseDateTo"
            />
          </div>
          <div>
            <md-radio v-model="BaseSelectType" value="date">日付</md-radio>
            <md-radio v-model="BaseSelectType" value="day">曜日</md-radio>
          </div>
          <div v-if="BaseSelectTypeIsDate">
            <div class="term-input">
              <!-- 日付選択 -->
              <md-field class="divider">
                <md-select v-model="BaseSelectedDates" multiple>
                  <md-option
                    v-for="date in selectedDateOptions"
                    :value="date.id"
                    :key="date.id"
                  >
                    {{ date.label }}
                  </md-option>
                </md-select>
              </md-field>
              <gl-button
                @click="$emit('update:base', { ...base, selectedDates: [] })"
                class="clear-button"
                >Clear All</gl-button
              >
            </div>
            <div class="chips">
              <transition-group name="chips" tag="div">
                <gl-chip
                  v-for="d in BaseSelectedDatesForChips"
                  :key="d.id"
                  @delete="deleteDateItem('base', d.id)"
                  primary
                  deletable
                  >{{ d.label }}</gl-chip
                >
              </transition-group>
            </div>
          </div>
          <div v-else>
            <div class="term-input">
              <!-- 曜日選択 -->
              <md-field class="divider">
                <md-select v-model="BaseSelectedDays" multiple>
                  <md-option
                    v-for="day in selectedDayOptions"
                    :value="day.id"
                    :key="day.id"
                  >
                    {{ day.label }}
                  </md-option>
                </md-select>
              </md-field>
              <gl-button
                @click="$emit('update:base', { ...base, selectedDays: [] })"
                class="clear-button"
                >Clear All</gl-button
              >
            </div>
            <transition-group name="chips" tag="div">
              <gl-chip
                v-for="d in BaseSelectedDaysForChips"
                :key="d.id"
                @delete="deleteDayItem('base', d.id)"
                primary
                deletable
                >{{ d.label }}</gl-chip
              >
            </transition-group>
          </div>
          <!-- 前期 -->
          <div class="term-input">
            <gl-input-date
              :min="minDate"
              :max="maxDate"
              :value.sync="CompareDateFrom"
            />
            <div class="divider">～</div>
            <gl-input-date
              :min="minDate"
              :max="maxDate"
              :value.sync="CompareDateTo"
            />
          </div>
          <div>
            <md-radio v-model="CompareSelectType" value="date">日付</md-radio>
            <md-radio v-model="CompareSelectType" value="day">曜日</md-radio>
          </div>
          <div v-if="CompareSelectTypeIsDate">
            <div class="term-input">
              <!-- 日付選択 -->
              <md-field class="divider">
                <md-select v-model="CompareSelectedDates" multiple>
                  <md-option
                    v-for="date in selectedDateOptions"
                    :value="date.id"
                    :key="date.id"
                  >
                    {{ date.label }}
                  </md-option>
                </md-select>
              </md-field>
              <gl-button
                @click="
                  $emit('update:compare', {
                    ...compare,
                    selectedDates: [],
                  })
                "
                class="clear-button"
                >Clear All</gl-button
              >
            </div>
            <div class="chips">
              <transition-group name="chips" tag="div">
                <gl-chip
                  v-for="d in CompareSelectedDatesForChips"
                  :key="d.id"
                  @delete="deleteDateItem('compare', d.id)"
                  primary
                  deletable
                  >{{ d.label }}</gl-chip
                >
              </transition-group>
            </div>
          </div>
          <div v-else>
            <div class="term-input">
              <!-- 曜日選択 -->
              <md-field class="divider">
                <md-select v-model="CompareSelectedDays" multiple>
                  <md-option
                    v-for="day in selectedDayOptions"
                    :value="day.id"
                    :key="day.id"
                  >
                    {{ day.label }}
                  </md-option>
                </md-select>
              </md-field>
              <gl-button
                @click="
                  $emit('update:compare', { ...compare, selectedDays: [] })
                "
                class="clear-button"
                >Clear All</gl-button
              >
            </div>
            <transition-group name="chips" tag="div">
              <gl-chip
                v-for="d in CompareSelectedDaysForChips"
                :key="d.id"
                @delete="deleteDayItem('compare', d.id)"
                primary
                deletable
                >{{ d.label }}</gl-chip
              >
            </transition-group>
          </div>
        </div>
      </transition>
    </div>
    <md-snackbar
      md-position="center"
      :md-duration="snackbar.duration"
      :md-active.sync="snackbar.show"
      md-persistent
    >
      {{ snackbar.message }}
    </md-snackbar>
  </div>
</template>
<script>
import moment from 'moment'
import GlSelectMonth from '@/components/common/GlSelectMonth.vue'
import GlInputDate from '@/components/common/GlInputDate.vue'
import GlChip from '@/components/common/GlChip.vue'
import {
  getStartDateByWeekCount,
  getEndDateByWeekCount,
  getStartDateByMonthCount,
  weekMove,
  monthMove,
  dateLimit,
} from '@/util/date'
import ErrorReport from '@/mixins/ErrorReport'
import QueryFilterRestoreMixin from '@/mixins/QueryFilterRestoreMixin'
import {
  SELECTED_DAY_OPTIONS,
  SELECTED_DATE_OPTIONS,
} from '@/const/termSelectOptions'
// 通常（このコンポーネントへの入力や出力）で利用する日付フォーマット
const DATE_FORMAT = 'YYYYMMDD'
// 週の初期値設定
const DEFAULT_WEEK_COUNT = 13

// 期間選択コンポーネント

// 内部的には開始、終了日だけを保持し、週や月の値は現在選択されている日付
// から算出して取得・設定します。
// なので、選択方式に週や月を選んでいてもこのコンポーネントから取得できるのは "日" です。

export default {
  mixins: [ErrorReport, QueryFilterRestoreMixin],
  data() {
    return {
      termTypes: [
        { id: 'w', label: '週' },
        { id: 'm', label: '月' },
        { id: 'd', label: '日' },
        { id: 'select', label: '日・曜日選択' },
      ],
      weekTypes: [
        { id: 'COUNT_FROM', label: 'から' },
        { id: 'COUNT_TO', label: 'まで' },
      ],
      selectedDateOptions: SELECTED_DATE_OPTIONS,
      selectedDayOptions: SELECTED_DAY_OPTIONS,
      // Snackbarの表示制御用のデータ
      snackbar: {
        show: false,
        duration: 10000,
        message: '',
      },
    }
  },
  components: { GlSelectMonth, GlInputDate, GlChip },
  props: {
    // 選択している選択種別（日 / 週 / 月）
    termType: {
      type: String,
      default: 'w',
    },
    base: {
      dateFrom: {
        type: String,
        validator(value) {
          const regex = new RegExp(/^\d{8}$/g)
          return regex.test(value)
        },
      },
      dateTo: {
        type: String,
        validator(value) {
          const regex = new RegExp(/^\d{8}$/g)
          return regex.test(value)
        },
      },
      weekType: {
        type: String,
        default: 'COUNT_TO',
      },
      // 日付選択か曜日選択
      selectType: {
        type: String,
        default: 'date',
      },
      // 選択した日付のリスト
      selectedDates: {
        type: Array,
        default: () => [],
      },
      // 選択した曜日のリスト
      selectedDays: {
        type: Array,
        default: () => [],
      },
    },
    compare: {
      dateFrom: {
        type: String,
        validator(value) {
          const regex = new RegExp(/^\d{8}$/g)
          return regex.test(value)
        },
      },
      dateTo: {
        type: String,
        validator(value) {
          const regex = new RegExp(/^\d{8}$/g)
          return regex.test(value)
        },
      },
      weekType: {
        type: String,
        default: 'COUNT_TO',
      },
      // 日付選択か曜日選択
      selectType: {
        type: String,
        default: 'date',
      },
      // 選択した日付のリスト
      selectedDates: {
        type: Array,
        default: () => [],
      },
      // 選択した曜日のリスト
      selectedDays: {
        type: Array,
        default: () => [],
      },
    },
    /**
     * 選択可能な期間種別
     */
    visibleTermTypes: {
      type: Array,
      default: () => ['w', 'm'],
    },
  },
  watch: {
    /**
     * 最大日付の変更時、現在の日付値が上限を超えていないか確認し、
     * 超えている場合は新しい上限に自動調整します。
     */
    maxDate() {
      this.adjustRangeIfNeeded()
    },
    minDate() {
      this.adjustRangeIfNeeded()
    },
    /**
     * 選択種別の変更時、現在設定されている開始・終了日から、変更先の種別で適切となる
     * 開始・終了日に変換します。
     *
     * 例）"日" ⇒ "月" に変更した場合、"開始日" は月初の日付になり、"終了日" は月末の日付になります。
     *     2019/01/14～2019/05/03 -> 2019/01(2019/01/01)～2019/05(2019/05/31)
     */
    termType(value) {
      this.$emit('update:termType', value)
      let basedateFrom = this.base.dateFrom
      let basedateTo = this.base.dateTo
      let comparedateFrom = this.compare.dateFrom
      let comparedateTo = this.compare.dateTo
      // dateFrom, dateToはpropでもらい、親コンポーネントと.syncするので、
      // `update:dateFrom`, `update:dateTo` をemitするだけです。
      switch (value) {
        case 'w':
          // 週の場合終了日は表示されませんが、内部的には開始日からx週間後の日付を保持します。
          // 当期
          basedateTo = getEndDateByWeekCount(basedateFrom, this.BaseWeekCount)
          basedateTo = dateLimit(basedateTo, this.minDate, this.maxDate)
          this.$emit('update:base', {
            ...this.base,
            dateFrom: basedateFrom,
            dateTo: basedateTo,
          })
          // 前期
          comparedateTo = getEndDateByWeekCount(
            comparedateFrom,
            this.CompareWeekCount,
          )
          comparedateTo = dateLimit(comparedateTo, this.minDate, this.maxDate)
          this.$emit('update:compare', {
            ...this.compare,
            dateFrom: comparedateFrom,
            dateTo: comparedateTo,
          })
          break
        case 'm':
          // 当期
          basedateFrom = moment(basedateFrom)
            .startOf('month')
            .format(DATE_FORMAT)
          basedateTo = moment(basedateTo)
            .endOf('month')
            .format(DATE_FORMAT)
          basedateFrom = dateLimit(basedateFrom, this.minDate, this.maxDate)
          basedateTo = dateLimit(basedateTo, this.minDate, this.maxDate)
          this.$emit('update:base', {
            ...this.base,
            dateFrom: basedateFrom,
            dateTo: basedateTo,
          })
          // 前期
          comparedateFrom = moment(comparedateFrom)
            .startOf('month')
            .format(DATE_FORMAT)
          comparedateTo = moment(comparedateTo)
            .endOf('month')
            .format(DATE_FORMAT)
          comparedateFrom = dateLimit(
            comparedateFrom,
            this.minDate,
            this.maxDate,
          )
          comparedateTo = dateLimit(comparedateTo, this.minDate, this.maxDate)
          this.$emit('update:compare', {
            ...this.compare,
            dateFrom: comparedateFrom,
            dateTo: comparedateTo,
          })
          break
        default:
          break
      }
    },
  },
  computed: {
    minDate() {
      return this.$store.getters.calendarEffectiveMinDate
    },
    maxDate() {
      return this.$store.getters.calendarEffectiveMaxDate
    },
    _termType: {
      get() {
        if (!this.visibleTermTypes.includes(this.termType)) {
          this.$emit('update:termType', this.filteredTermTypes[0].id || 'd')
        }
        return this.termType
      },
      set(newVal) {
        this.$emit('update:termType', newVal)
      },
    },
    isDateMode() {
      return this.termType === 'd'
    },
    isWeekMode() {
      return this.termType === 'w'
    },
    isMonthMode() {
      return this.termType === 'm'
    },
    isSelectMode() {
      return this.termType === 'select'
    },
    baseWeekCountFrom() {
      return this.base.weekType === 'COUNT_FROM'
    },
    baseWeekCountTo() {
      return this.base.weekType === 'COUNT_TO'
    },
    compareWeekCountFrom() {
      return this.compare.weekType === 'COUNT_FROM'
    },
    compareWeekCountTo() {
      return this.compare.weekType === 'COUNT_TO'
    },
    // 週の選択範囲は7日に満たない日数を選択出来る様プラス１しています。
    // 当期
    BaseMaxWeek() {
      if (this.baseWeekCountFrom) {
        // から
        return moment(this.maxDate).diff(this.base.dateFrom, 'weeks') + 1
      } else {
        // まで
        return moment(this.base.dateTo).diff(this.minDate, 'weeks') + 1
      }
    },
    // 前期
    CompareMaxWeek() {
      if (this.compareWeekCountFrom) {
        // から
        return moment(this.maxDate).diff(this.compare.dateFrom, 'weeks') + 1
      } else {
        // まで
        return moment(this.compare.dateTo).diff(this.minDate, 'weeks') + 1
      }
    },
    // 当期日開始選択
    BaseDateFrom: {
      get() {
        return this.base.dateFrom
      },
      set(newVal) {
        newVal = dateLimit(newVal, this.minDate, this.maxDate)
        this.$emit('update:base', { ...this.base, dateFrom: newVal })
      },
    },
    // 当期日付末選択
    BaseDateTo: {
      get() {
        return this.base.dateTo
      },
      set(newVal) {
        newVal = dateLimit(newVal, this.minDate, this.maxDate)
        this.$emit('update:base', { ...this.base, dateTo: newVal })
      },
    },
    // 前期 日選択 開始
    CompareDateFrom: {
      get() {
        return this.compare.dateFrom
      },
      set(newVal) {
        newVal = dateLimit(newVal, this.minDate, this.maxDate)
        this.$emit('update:compare', { ...this.compare, dateFrom: newVal })
      },
    },
    // 前期 日選択 終了
    CompareDateTo: {
      get() {
        return this.compare.dateTo
      },
      set(newVal) {
        newVal = dateLimit(newVal, this.minDate, this.maxDate)
        this.$emit('update:compare', { ...this.compare, dateTo: newVal })
      },
    },
    // 当期の週選択
    BaseWeekCount: {
      get() {
        return (
          moment(this.base.dateTo).diff(moment(this.base.dateFrom), 'weeks') + 1
        )
      },
      set(newVal) {
        if (this.baseWeekCountFrom) {
          let dateFrom = this.base.dateFrom
          let dateTo = getEndDateByWeekCount(dateFrom, newVal)
          dateTo = dateLimit(dateTo, this.minDate, this.maxDate)
          this.$emit('update:base', {
            ...this.base,
            dateTo: dateTo,
          })
        } else if (this.baseWeekCountTo) {
          let dateTo = this.base.dateTo
          newVal = getStartDateByWeekCount(dateTo, newVal)
          newVal = dateLimit(newVal, this.minDate, this.maxDate)
          this.$emit('update:base', {
            ...this.base,
            dateFrom: newVal,
          })
        }
      },
    },
    // 前期の週選択
    CompareWeekCount: {
      get() {
        return (
          moment(this.compare.dateTo).diff(
            moment(this.compare.dateFrom),
            'weeks',
          ) + 1
        )
      },
      set(newVal) {
        if (this.compareWeekCountFrom) {
          let dateFrom = this.compare.dateFrom
          let dateTo = getEndDateByWeekCount(dateFrom, newVal)
          dateTo = dateLimit(dateTo, this.minDate, this.maxDate)
          this.$emit('update:compare', {
            ...this.compare,
            dateTo: dateTo,
          })
        } else if (this.compareWeekCountTo) {
          let dateTo = this.compare.dateTo
          newVal = getStartDateByWeekCount(dateTo, newVal)
          newVal = dateLimit(newVal, this.minDate, this.maxDate)
          this.$emit('update:compare', {
            ...this.compare,
            dateFrom: newVal,
          })
        }
      },
    },
    // 当期月の選択範囲
    BaseMaxMonth() {
      return moment(this.base.dateTo).diff(this.minDate, 'months') + 2
    },
    // 前期月の選択範囲
    CompareMaxMonth() {
      return moment(this.compare.dateTo).diff(this.minDate, 'months') + 2
    },
    // 月の選択処理
    // 当期
    BaseMonthTo: {
      get() {
        return moment(this.base.dateTo).format('YYYYMM')
      },
      set(newVal) {
        let dateTo = moment(newVal)
          .endOf('month')
          .format(DATE_FORMAT)
        dateTo = dateLimit(dateTo, this.minDate, this.maxDate)
        let dateFrom = monthMove(this.base.dateFrom, this.base.dateTo, dateTo)
        dateFrom = dateLimit(dateFrom, this.minDate, this.maxDate)
        this.$emit('update:base', {
          ...this.base,
          dateFrom: dateFrom,
          dateTo: dateTo,
        })
      },
    },
    // 前期
    CompareMonthTo: {
      get() {
        return moment(this.compare.dateTo).format('YYYYMM')
      },
      set(newVal) {
        let dateTo = moment(newVal)
          .endOf('month')
          .format(DATE_FORMAT)
        dateTo = dateLimit(dateTo, this.minDate, this.maxDate)
        let dateFrom = monthMove(
          this.compare.dateFrom,
          this.compare.dateTo,
          dateTo,
        )
        dateFrom = dateLimit(dateFrom, this.minDate, this.maxDate)
        this.$emit('update:compare', {
          ...this.compare,
          dateFrom: dateFrom,
          dateTo: dateTo,
        })
      },
    },
    // ここで選択された月数から期間末日を出す
    // 当期選択された月期間の計算
    BaseMonthCount: {
      get() {
        return (
          moment(this.base.dateTo, DATE_FORMAT).diff(
            moment(this.base.dateFrom, DATE_FORMAT),
            'months',
          ) + 1
        )
      },
      set(MonthCount) {
        const dateTo = this.base.dateTo
        let dateFrom = getStartDateByMonthCount(dateTo, MonthCount)
        dateFrom = dateLimit(dateFrom, this.minDate, this.maxDate)
        this.$emit('update:base', {
          ...this.base,
          dateFrom: dateFrom,
          dateTo: dateTo,
        })
      },
    },
    // 前期選択された月期間の計算
    CompareMonthCount: {
      get() {
        return (
          moment(this.compare.dateTo, DATE_FORMAT).diff(
            moment(this.compare.dateFrom, DATE_FORMAT),
            'months',
          ) + 1
        )
      },
      set(MonthCount) {
        const dateTo = this.compare.dateTo
        let dateFrom = getStartDateByMonthCount(dateTo, MonthCount)
        dateFrom = dateLimit(dateFrom, this.minDate, this.maxDate)
        this.$emit('update:compare', {
          ...this.compare,
          dateFrom: dateFrom,
          dateTo: dateTo,
        })
      },
    },
    /**
     * 期間のラジオボタン
     */
    filteredTermTypes() {
      return this.termTypes.filter(f => this.visibleTermTypes.includes(f.id))
    },
    /**
     * ～から、～までの選択肢が変更された際weekTypeを変更します
     */
    _baseWeekType: {
      get() {
        return this.base.weekType
      },
      set(newVal) {
        this.$emit('update:base', {
          ...this.base,
          weekType: newVal,
        })
      },
    },
    /**
     * termTypeが週で開始日が変更された場合ここで変更保存をしています。
     * x週間の間隔を保つため終了日も一緒に変更保存。
     */
    BaseWeekFrom: {
      get() {
        return this.base.dateFrom
      },
      set(newVal) {
        newVal = dateLimit(newVal, this.minDate, this.maxDate)
        let dateTo = weekMove(this.base.dateTo, this.base.dateFrom, newVal)
        dateTo = dateLimit(dateTo, this.minDate, this.maxDate)
        this.$emit('update:base', {
          ...this.base,
          dateFrom: newVal,
          dateTo: dateTo,
        })
      },
    },
    BaseWeekTo: {
      get() {
        return this.base.dateTo
      },
      set(newVal) {
        let dateFrom = weekMove(this.base.dateFrom, this.base.dateTo, newVal)
        dateFrom = dateLimit(dateFrom, this.minDate, this.maxDate)
        newVal = dateLimit(newVal, this.minDate, this.maxDate)
        this.$emit('update:base', {
          ...this.base,
          dateFrom: dateFrom,
          dateTo: newVal,
        })
      },
    },
    /**
     * ～から、～までの選択肢が変更された際weekTypeを変更します
     */
    _compareWeekType: {
      get() {
        return this.compare.weekType
      },
      set(newVal) {
        this.$emit('update:compare', {
          ...this.compare,
          weekType: newVal,
        })
      },
    },
    /**
     * termTypeが週で開始日が変更された場合ここで変更保存をしています。
     * x週間の間隔を保つため終了日も一緒に変更保存。
     */
    CompareWeekFrom: {
      get() {
        return this.compare.dateFrom
      },
      set(newVal) {
        newVal = dateLimit(newVal, this.minDate, this.maxDate)
        let dateTo = weekMove(
          this.compare.dateTo,
          this.compare.dateFrom,
          newVal,
        )
        dateTo = dateLimit(dateTo, this.minDate, this.maxDate)
        this.$emit('update:compare', {
          ...this.compare,
          dateFrom: newVal,
          dateTo: dateTo,
        })
      },
    },
    CompareWeekTo: {
      get() {
        return this.compare.dateTo
      },
      set(newVal) {
        let dateFrom = weekMove(
          this.compare.dateFrom,
          this.compare.dateTo,
          newVal,
        )
        dateFrom = dateLimit(dateFrom, this.minDate, this.maxDate)
        newVal = dateLimit(newVal, this.minDate, this.maxDate)
        this.$emit('update:compare', {
          ...this.compare,
          dateFrom: dateFrom,
          dateTo: newVal,
        })
      },
    },
    /**
     * selectTypeが日付指定の場合True（日・曜日選択で使用）
     */
    BaseSelectTypeIsDate() {
      return this.base.selectType === 'date'
    },
    CompareSelectTypeIsDate() {
      return this.compare.selectType === 'date'
    },
    /**
     * 日付・曜日の選択肢が変更された際selectTypeを変更します
     */
    BaseSelectType: {
      get() {
        return this.base.selectType
      },
      set(newVal) {
        this.$emit('update:base', {
          ...this.base,
          selectType: newVal,
        })
      },
    },
    CompareSelectType: {
      get() {
        return this.compare.selectType
      },
      set(newVal) {
        this.$emit('update:compare', {
          ...this.compare,
          selectType: newVal,
        })
      },
    },
    /**
     * 選択している日付
     */
    BaseSelectedDates: {
      get() {
        return this.base.selectedDates || []
      },
      set(newVal) {
        this.$emit('update:base', {
          ...this.base,
          selectedDates: newVal,
        })
      },
    },
    CompareSelectedDates: {
      get() {
        return this.compare.selectedDates || []
      },
      set(newVal) {
        this.$emit('update:compare', {
          ...this.compare,
          selectedDates: newVal,
        })
      },
    },
    /**
     * 選択している日付（Chip用）
     */
    BaseSelectedDatesForChips: {
      get() {
        return [...this.selectedDateOptions]
          .filter(f => this.BaseSelectedDates.some(s => s === f.id))
          .sort((a, b) => a.id - b.id)
      },
      set(newVal) {
        this.$emit('update:base', {
          ...this.base,
          selectedDates: newVal,
        })
      },
    },
    CompareSelectedDatesForChips: {
      get() {
        return [...this.selectedDateOptions]
          .filter(f => this.CompareSelectedDates.some(s => s === f.id))
          .sort((a, b) => a.id - b.id)
      },
      set(newVal) {
        this.$emit('update:compare', {
          ...this.compare,
          selectedDates: newVal,
        })
      },
    },
    /**
     * 選択している曜日
     */
    BaseSelectedDays: {
      get() {
        return this.base.selectedDays || []
      },
      set(newVal) {
        this.$emit('update:base', {
          ...this.base,
          selectedDays: newVal,
        })
      },
    },
    CompareSelectedDays: {
      get() {
        return this.compare.selectedDays || []
      },
      set(newVal) {
        this.$emit('update:compare', {
          ...this.compare,
          selectedDays: newVal,
        })
      },
    },
    /**
     * 選択している曜日（Chip用）
     */
    BaseSelectedDaysForChips: {
      get() {
        return [...this.selectedDayOptions]
          .filter(f => this.BaseSelectedDays.some(s => s === f.id))
          .sort((a, b) => a.order - b.order)
      },
      set(newVal) {
        this.$emit('update:base', {
          ...this.base,
          selectedDays: newVal,
        })
      },
    },
    CompareSelectedDaysForChips: {
      get() {
        return [...this.selectedDayOptions]
          .filter(f => this.CompareSelectedDays.some(s => s === f.id))
          .sort((a, b) => a.order - b.order)
      },
      set(newVal) {
        this.$emit('update:compare', {
          ...this.compare,
          selectedDays: newVal,
        })
      },
    },
    errors() {
      const errors = []
      if (this.base.dateFrom && this.base.dateTo) {
        if (this.base.dateFrom > this.base.dateTo) {
          errors.push('当期間の終了期間は開始期間以降を選択してください')
        }
      } else {
        errors.push('当期間を選択してください')
      }
      if (this.compare.dateFrom && this.compare.dateTo) {
        if (this.compare.dateFrom > this.compare.dateTo) {
          errors.push('前期間の終了期間は開始期間以降を選択してください')
        }
      } else {
        errors.push('前期間を選択してください')
      }
      // 日・曜日選択で選択している日付または曜日が無い場合
      if (this.isSelectMode) {
        if (this.BaseSelectTypeIsDate) {
          if (!this.BaseSelectedDates || this.BaseSelectedDates.length === 0) {
            errors.push('当期間の対象日付を1つ以上選択してください')
          }
        } else {
          if (!this.BaseSelectedDays || this.BaseSelectedDays.length === 0) {
            errors.push('当期間の対象曜日を1つ以上選択してください')
          }
        }
        if (this.CompareSelectTypeIsDate) {
          if (
            !this.CompareSelectedDates ||
            this.CompareSelectedDates.length === 0
          ) {
            errors.push('前期間の対象日付を1つ以上選択してください')
          }
        } else {
          if (
            !this.CompareSelectedDays ||
            this.CompareSelectedDays.length === 0
          ) {
            errors.push('前期間の対象曜日を1つ以上選択してください')
          }
        }
      }
      return errors
    },
  },
  methods: {
    deleteDateItem(periodType, id) {
      if (periodType === 'base') {
        this.BaseSelectedDates = this.BaseSelectedDates.filter(f => f !== id)
      } else {
        this.CompareSelectedDates = this.CompareSelectedDates.filter(
          f => f !== id,
        )
      }
    },
    deleteDayItem(periodType, id) {
      if (periodType === 'base') {
        this.BaseSelectedDays = this.BaseSelectedDays.filter(f => f !== id)
      } else {
        this.CompareSelectedDays = this.CompareSelectedDays.filter(
          f => f !== id,
        )
      }
    },
    adjustRangeIfNeeded() {
      // QueryFilterRestoreMixinのcomputedを参照
      if (this._queryFilterRestoring) return

      const baseDateFromAdjusted = dateLimit(
        this.base.dateFrom,
        this.minDate,
        this.maxDate,
      )
      const baseDateToAdjusted = dateLimit(
        this.base.dateTo,
        this.minDate,
        this.maxDate,
      )
      const compareDateFromAdjusted = dateLimit(
        this.compare.dateFrom,
        this.minDate,
        this.maxDate,
      )
      const compareDateToAdjusted = dateLimit(
        this.compare.dateTo,
        this.minDate,
        this.maxDate,
      )

      if (
        baseDateFromAdjusted !== this.base.dateFrom ||
        baseDateToAdjusted !== this.base.dateTo
      ) {
        this.$emit('update:base', {
          ...this.base,
          dateFrom: baseDateFromAdjusted,
          dateTo: baseDateToAdjusted,
        })
        this.snackbar.message =
          '(対象期間)指定期間が選択可能な期間外だったため、自動調整しました。'
        this.snackbar.show = true
      }

      if (
        compareDateFromAdjusted !== this.compare.dateFrom ||
        compareDateToAdjusted !== this.compare.dateTo
      ) {
        this.snackbar.message =
          '(比較期間)指定期間が選択可能な期間外です。前期間の指定を見直してください。'
        this.snackbar.show = true
      }
    },
    // QueryFilterRestoreMixinのmethodsを上書き
    // 分析条件の復元が完了したときの処理
    onQueryFilterRestoreCompleted() {
      this.adjustRangeIfNeeded()
    },
  },
  async created() {
    let BaseDateFrom = this.base.dateFrom
    let BaseDateTo = this.base.dateTo
    let CompareDateFrom = this.compare.dateFrom
    let CompareDateTo = this.compare.dateTo

    // 検索期間の初期値指定、任意の初期値がある場合はelseへ
    // 検索期限は外部APIから取得する必要がある為、ここに記述
    // 当期
    if (!BaseDateFrom || !BaseDateTo) {
      BaseDateFrom = moment(this.maxDate)
        .subtract(DEFAULT_WEEK_COUNT, 'week')
        .add(1, 'days')
        .format(DATE_FORMAT)
      BaseDateTo = this.maxDate
      // 検索期間が検索期限を超えていた場合の処理
      BaseDateFrom = dateLimit(BaseDateFrom, this.minDate, this.maxDate)
      BaseDateTo = dateLimit(BaseDateTo, this.minDate, this.maxDate)
      this.$emit('update:base', {
        ...this.base,
        dateFrom: BaseDateFrom,
        dateTo: BaseDateTo,
        weekType: this.base.weekType,
      })
    }
    // 前期
    if (!CompareDateFrom || !CompareDateTo) {
      CompareDateFrom = moment(this.maxDate)
        .subtract(DEFAULT_WEEK_COUNT, 'week')
        .add(1, 'days')
        .format(DATE_FORMAT)
      CompareDateTo = this.maxDate
      // 検索期間が検索期限を超えていた場合の処理
      CompareDateFrom = dateLimit(CompareDateFrom, this.minDate, this.maxDate)
      CompareDateTo = dateLimit(CompareDateTo, this.minDate, this.maxDate)
      this.$emit('update:compare', {
        ...this.compare,
        dateFrom: CompareDateFrom,
        dateTo: CompareDateTo,
        weekType: this.compare.weekType,
      })
    }
  },
}
</script>

<style lang="scss" scoped>
.container {
  overflow: hidden;
}

.term-input {
  display: flex;
}

.week-count {
  width: 70px;
}

.clear-button {
  margin-top: 16px;
}

.divider {
  align-items: center;
  display: flex;
  justify-content: center;
  margin-left: 16px;
  margin-right: 16px;
  white-space: nowrap;
}

.weekType {
  width: 70px;
  align-items: center;
  display: flex;
  justify-content: center;
  margin-left: 16px;
  margin-right: 16px;
  white-space: nowrap;
}

// 期間選択エリアの切替アニメーション
.v-enter-active,
.v-leave-active {
  transition: transform 0.1s ease-in-out, opacity 0.1s ease-in-out;
}
.v-enter,
.v-leave-to {
  opacity: 0;
}
.v-enter {
  transform: translateX(-50%);
}
.v-leave-to {
  transform: translateX(50%);
}
.gl-chip {
  margin-left: var(--spacing-small);
  margin-top: var(--spacing-small);
  // For Transition Animation
  display: inline-block;
}

// Chips Animation
.chips-enter,
.chips-leave-to {
  opacity: 0;
}
.chips-leave-active {
  position: absolute;
}
.chips-move {
  transition: transform 0.3s;
}
</style>
